export const EVENT_CATEGORIES = [
  'Social', 'Kids', 'Sports', 'Food', 'Workshop', 'Networking', 'Health', 'Education', 'Other',
] as const;

export const EVENT_EMOJI: Record<string, string> = {
  Social: '🎉', Kids: '🧒', Sports: '⚽', Food: '🍽️',
  Workshop: '🔧', Networking: '🤝', Health: '💊', Education: '📚', Other: '📅',
};

export const EVENT_GRADIENT: Record<string, string> = {
  Social:     'linear-gradient(135deg, #7c3aed 0%, #4c1d95 100%)',
  Kids:       'linear-gradient(135deg, #f59e0b 0%, #b45309 100%)',
  Sports:     'linear-gradient(135deg, #10b981 0%, #065f46 100%)',
  Food:       'linear-gradient(135deg, #ef4444 0%, #991b1b 100%)',
  Workshop:   'linear-gradient(135deg, #6366f1 0%, #3730a3 100%)',
  Networking: 'linear-gradient(135deg, #0ea5e9 0%, #0c4a6e 100%)',
  Health:     'linear-gradient(135deg, #ec4899 0%, #831843 100%)',
  Education:  'linear-gradient(135deg, #f97316 0%, #7c2d12 100%)',
  Other:      'linear-gradient(135deg, #64748b 0%, #1e293b 100%)',
};
